import { render, staticRenderFns } from "./HolderVisitRecord.vue?vue&type=template&id=36ab5b38"
import script from "./HolderVisitRecord.vue?vue&type=script&lang=js"
export * from "./HolderVisitRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports